import React, { useEffect, useRef } from 'react';
import { pageImageUrl } from './api';
import { playTurn } from './sound';

interface Props {
  date: string;
  pageCount: number;
  page: number;
  onGo: (page: number) => void;
  imgUrl?: (page: number) => string; // picture address (default: the signed-in reader's)
}

/** The pages of this paper as small slides, one under the other. Clicking a slide opens that page. */
export function PageSlides({ date, pageCount, page, onGo, imgUrl }: Props) {
  const cur = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    cur.current?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }, [page, date]);

  return (
    <div className="slides" role="list" aria-label="Pages of this paper">
      {Array.from({ length: pageCount }, (_, i) => i + 1).map((p) => (
        <button
          key={date + ':' + p}
          ref={p === page ? cur : undefined}
          role="listitem"
          className={'slide' + (p === page ? ' cur' : '')}
          aria-current={p === page ? 'page' : undefined}
          aria-label={'Go to page ' + p}
          onClick={() => {
            if (p !== page) {
              playTurn(p > page ? 'next' : 'prev', p);
              onGo(p);
            }
          }}
        >
          <img src={imgUrl ? imgUrl(p) : pageImageUrl(date, p, 400)} loading="lazy" alt="" draggable={false} />
          <span className="slide-no">{p}</span>
        </button>
      ))}
    </div>
  );
}
